import { styled } from 'styled-components'

interface LogoutModalProps {
    isOpen: boolean
    onConfirm: () => void
    onCancel: () => void
}

const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`

const ModalContent = styled.div`
    background-color: white;
    padding: 60px 80px;
    border-radius: 10px;
    text-align: center;
    max-width: 500px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
`

const ModalText = styled.p`
    font-size: 20px;
    color: #333;
    margin-bottom: 40px;
    line-height: 1.5;
`

const ButtonsWrapper = styled.div`
    display: flex;
    justify-content: center;
    gap: 10px;
`

const ConfirmButton = styled.button`
    padding: 12px 32px;
    border-radius: 50px;
    cursor: pointer;
    border: none;
    background-color: #ff4444;
    color: #ffffff;
    font-size: 16px;
    font-weight: 500;
    &:hover {
        background-color: #cc0000;
    }
`

const CancelButton = styled.button`
    padding: 12px 32px;
    border-radius: 50px;
    cursor: pointer;
    border: 1px solid #ccc;
    background-color: #ffffff;
    color: #333;
    font-size: 16px;
    font-weight: 500;
    margin-left: 10px;
    &:hover {
        background-color: #f5f5f5;
    }
`

export default function LogoutModal({
    isOpen,
    onConfirm,
    onCancel,
}: LogoutModalProps) {
    if (!isOpen) {
        return null
    }

    return (
        <ModalOverlay onClick={onCancel}>
            <ModalContent onClick={(e) => e.stopPropagation()}>
                <ModalText>
                    Are you sure you want to log out your account?
                </ModalText>
                <ButtonsWrapper>
                    <ConfirmButton onClick={onConfirm}>
                        Yes, log out
                    </ConfirmButton>
                    <CancelButton onClick={onCancel}>Cancel</CancelButton>
                </ButtonsWrapper>
            </ModalContent>
        </ModalOverlay>
    )
}
